import { __ } from "@jti/fe-common";
export const translatedPaymentMethodsEvo = (data) => {
    if (!data)
        return [];
    return data.map((paymentMethod) => {
        var _a, _b, _c, _d;
        const text = __(`cart.order.payment_method.${paymentMethod.code}`, undefined, paymentMethod.title);
        return {
            code: (_a = paymentMethod.code) !== null && _a !== void 0 ? _a : "",
            description: (_b = paymentMethod.description) !== null && _b !== void 0 ? _b : "",
            icon: (_c = paymentMethod.icon) !== null && _c !== void 0 ? _c : "",
            tokenizable: (_d = paymentMethod.tokenizable) !== null && _d !== void 0 ? _d : false,
            title: text,
        };
    });
};
//# sourceMappingURL=translatePaymentMethodsEvo.js.map